<div class="modal-container">
  <div class="multifilter-container">
    <app-multi-filter [fromAdmin]="fromAdmin" class="multi-filter"></app-multi-filter>
  </div>
  <div class="fab" (click)="closeModal()">
    <div [hidden]="filtersChanged" class="w-100">Close</div>
    <div [hidden]="!filtersChanged" class="w-100">Apply</div>
  </div>
</div>
